import {TextField} from '@mui/material';
import {DatePicker, LocalizationProvider} from '@mui/x-date-pickers';
import React from 'react'
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';

const DateTo = ({dateTo, setDateTo, dateFrom, label}) => {

    const isDateDisabled = (date) => {
        // Disable dates before dateFrom and after maxDate
        return date < new Date(dateFrom);
    };

    const handleChange = (newValue) => {
        const selectedDate = new Date(newValue);

        const dayTo = selectedDate.getDate().toString().padStart(2, '0');
        const monthTo = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
        const yearTo = selectedDate.getFullYear();
        const convertedDateTo = `${yearTo}-${monthTo}-${dayTo}`;

        setDateTo(convertedDateTo);
    };


    return (
        <>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    inputFormat="DD/MM/YYYY"
                    value={dateTo}
                    onChange={handleChange}
                    componentsProps={{
                        actionBar: {actions: ["clear", "today",]},
                    }}
                    shouldDisableDate={isDateDisabled} // Set the function to disable dates
                    renderInput={(params) => <TextField {...params} label={label ?? "Date To"} size="small" fullWidth/>}
                />
            </LocalizationProvider>
        </>
    )
}

export default DateTo;